<template>
	<button class="lt" aria-label="Activar lista de canais" @click="$store.commit('toggleSidebar')" />
</template>

<script>
export default {
	name: "SidebarToggle",
};
</script>
